<template>
  <router-link
    v-if="canNavigate"
    :to="{
      name: 'CompanyDetails',
      params: { companyUUID: String(companyUUID) },
    }"
    class="company-link"
    :class="{ 'company-link-inherit': inheritColor }"
    @click.native.stop
  >
    <slot>{{ companyName }}</slot>
  </router-link>
  <span v-else>
    <slot>{{ companyName }}</slot>
  </span>
</template>
<script>
export default {
  name: "CompanyLink",
  props: {
    company: { type: [Object, String], default: null },
    uuid: { type: [String, Number], default: null },
    name: { type: [String, Number], default: "" },
    fallback: { type: String, default: "-" },
    inheritColor: { type: Boolean, default: false },
  },
  computed: {
    companyUUID() {
      return (
        this.uuid ||
        (typeof this.company === "object" && this.company
          ? this.company.uuid || this.company.value
          : null)
      );
    },
    companyName() {
      return (
        this.name ||
        (typeof this.company === "string"
          ? this.company
          : this.company?.name ||
            this.company?.displayName ||
            this.company?.display_name ||
            this.company?.text) ||
        this.fallback
      );
    },
    canNavigate() {
      const containsRoute = (routes) =>
        routes.some(
          (route) =>
            route.name === "CompanyDetails" ||
            containsRoute(route.children || []),
        );
      return Boolean(
        this.companyUUID && containsRoute(this.$router.options.routes || []),
      );
    },
  },
};
</script>
<style scoped>
.company-link {
  overflow-wrap: anywhere;
}
.company-link-inherit {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.company-link:hover {
  text-decoration: underline;
}
</style>
